export enum PartOfSchoolYear {
  firstHalf,
  secondHalf,
}
